export const HEADER_HEIGHT = 80
export const SIDEBAR_WIDTH = 270
export const MAIN_WIDTH = window.innerWidth - SIDEBAR_WIDTH

export const COLORS = {
	HIGHLIGHT: '#9EEE8A',
	GREY_LIGHT: '#D9D9D9',
	GREY_DARK: '#B7B7B7',
	SELECTED: '#8AD6EE'
}